import React, { FC } from 'react'

import useApolloQuery, { isErr, isLoading } from 'src/hooks/useApolloQuery'

import { FETCH_SHARE_LINK_TOKEN_DETAILS } from 'src/graphql/board/shareLink'

import AvatarIcon from 'src/components/user/v2/avatar-icon'

import { ShareLinkWrapper } from './wrapper'
import { JoinBoard } from 'src/components/board/v2/share-link/join-board'
import { ShareLinkLoading } from './loading'
import { ShareLinkError } from './error'

interface ShareLinkProps {
  boardId: string
  tokenId: string
  boardTitle: string
  networkName: string
}

export const BoardShareLinkView: FC<ShareLinkProps> = ({
  boardId,
  boardTitle,
  tokenId,
  networkName
}) => {
  const res = useApolloQuery(FETCH_SHARE_LINK_TOKEN_DETAILS, {
    variables: { boardId, tokenId }
  })

  if (isLoading(res)) {
    return <ShareLinkLoading />
  }

  if (isErr(res)) {
    return <ShareLinkError />
  }

  const user = res.data.loggedInUser
  const { isBoardFollower, isShareLinkVisitor } = user

  return (
    <ShareLinkWrapper>
      <AvatarIcon className="m-auto mb-4" user={user} />
      <h2 className="text-base font-light text-neutral-600">
        You have reached the <span className="font-medium">{boardTitle}</span>{' '}
        community.
      </h2>
      <JoinBoard
        isBoardFollower={isBoardFollower}
        isShareLinkVisitor={isShareLinkVisitor}
        boardId={boardId}
        tokenId={tokenId}
        networkName={networkName}
      />
    </ShareLinkWrapper>
  )
}
